import {useMemo} from 'react';

import {useEntityFromLocation} from 'shared/hooks/use-entity-from-location';
import {useAppSelector} from 'store/config/hooks';
import {
    getRegionFromSubsectionCode,
    getRegionFromRegionCode,
    selectRegions,
} from 'store/slices/regions-slice';

export const useCurrentLocationRegionData = () => {
    const regions = useAppSelector(selectRegions);
    const {subsection} = useEntityFromLocation();

    const currentLocationRegionData = useMemo(() => {
        if (!regions) {
            return {};
        }

        const subRegionCode = subsection;
        const region = getRegionFromSubsectionCode(subRegionCode, regions)
                    || getRegionFromRegionCode(subRegionCode, regions);
        const subRegion = region?.subregionList.find(({code}) => code === subRegionCode);

        return {region, subRegion};
    }, [subsection, regions]);

    return {
        currentLocationRegion: currentLocationRegionData?.region,
        currentLocationSubregion: currentLocationRegionData?.subRegion,
    };
};
